// libraries
import React from "react";

// styles
import stlyes from "./styles.module.scss";

const Switch = ({ index, setIndex }) => {
  return (
    <div className={stlyes.switch}>
      <div className={stlyes.inner}>
        <button
          className={index === 1 ? stlyes.text_white : ""}
          onClick={() => setIndex(1)}
        >
          Log In
        </button>
        <button
          className={index === 2 ? stlyes.text_white : ""}
          onClick={() => setIndex(2)}
        >
          Register
        </button>
        <span
          className={`${stlyes.active} ${
            index === 1 ? stlyes.left : stlyes.right
          }`}
        />
      </div>
    </div>
  );
};

export default Switch;
